import React, { useEffect, useState, useRef } from "react";

var scrollTop = 0;
var lstTmpSubject = []

export const SybSubTable = ({ syllabusId, setTblKey, lstSubject, saveSybSubject }) => {
    const tableRef = useRef(null); // Reference to the table container
    const [scrollPosition, setScrollPosition] = useState(0); // Reference to store the scroll position

    const [lstSybSubject, setLstSybSubject] = useState([])
    const [lstAcademicCategory, setLstAcademicCategory] = useState([
        { academicCategoryId: 10, academicCategory: 'Scholastic' },
        { academicCategoryId: 20, academicCategory: 'Co-Scholastic' },
        { academicCategoryId: 30, academicCategory: 'Discipline' }
    ]);

    const [lstEvaluationType, setLstEvaluationType] = useState([
        { evaluationTypeId: 10, evaluationType: 'Score' },
        { evaluationTypeId: 20, evaluationType: 'Grade' }
    ]);

    useEffect(() => {
        lstTmpSubject = lstSubject
        setLstSybSubject(lstSubject)
        setScrollPosition(scrollTop)
    }, [])

    useEffect(() => {
        scrollToPosition(scrollTop)
    }, [scrollPosition]) 

    const scrollToPosition = (position) => {
        position = parseInt(Math.abs(position));
        let pos = position
        tableRef.current.scroll(0, pos)
    };
    async function handleCboxChange(pSubjectId, key, status) {
        var idx = existsIn(pSubjectId, lstTmpSubject);
        lstTmpSubject[idx][key] = status;
        if (key === "flgScholastic" || key === "flgEvaluation") {
            if (tableRef.current) {
                scrollTop = tableRef.current.scrollTop;
                // console.log('scrollTop=' + scrollTop)
                await setScrollPosition(scrollTop);
            }
            lstTmpSubject[idx][key] = parseInt(status);
            setLstSybSubject(lstTmpSubject)
            setTblKey(Math.round(Math.random() * 99999));
        }
    }

    function existsIn(subId, arr) {
        var idx = -1;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].subjectId === subId) {
                idx = i;
                break;
            }
        }
        return idx;
    }

    const colgrp = (
        <colgroup>
            <col width="25%"></col>
            <col width="10%"></col>
            <col width="10%"></col>
            <col width="20%"></col>
            <col width="20%"></col>
            <col width="10%"></col>
        </colgroup>
    );
    return <div>
        <table className='tableLayout1'>
            {colgrp}
            <thead>
                <tr>
                    <th>Subject</th>
                    <th>Exam</th>
                    <th>Report Card</th>
                    <th>Scholastic</th>
                    <th>Evaluation</th>
                    <th>Selective</th>
                </tr>
            </thead>
        </table>
        <div className='tablebodyWrapper tableBodyBorder' ref={tableRef}>
            <table className='tableLayout'>
                {colgrp}
                <tbody>
                    {lstSybSubject.map((obj, idx) => {
                        return (
                            <tr
                                key={'sub_' + idx}
                                id={obj.subjectId}
                            >
                                <td className='no-display'>{obj.subjectId}</td>
                                <td className=''>{obj.subject}</td>
                                <td className='text-center'><input
                                    type="checkbox"
                                    defaultChecked={obj.flgExam}
                                    onClick={(e) => handleCboxChange(obj.subjectId, 'flgExam', e.target.checked)} /></td>
                                <td className='text-center'>
                                    <input
                                        type="checkbox"
                                        defaultChecked={obj.flgReportCard}
                                        onClick={(e) => handleCboxChange(obj.subjectId, 'flgReportCard', e.target.checked)} />
                                </td>
                                <td>
                                    <select
                                        className='form-control'
                                        value={obj.flgScholastic}
                                        onChange={e => handleCboxChange(obj.subjectId, 'flgScholastic', e.target.value)}
                                    >
                                        <option value={0}>Academic Category</option>
                                        {lstAcademicCategory.map((obj, idx) => {
                                            return (
                                                <option key={'ac_' + idx} value={'' + obj.academicCategoryId}>
                                                    {obj.academicCategory}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </td>
                                <td className='text-left'>
                                    <select
                                        className='form-control'
                                        value={obj.flgEvaluation}
                                        onChange={e => handleCboxChange(obj.subjectId, 'flgEvaluation', e.target.value)}
                                    >
                                        <option value={0}>Evaluation Type</option>
                                        {lstEvaluationType.map((obj, idx) => {
                                            return (
                                                <option key={'ev_' + idx} value={'' + obj.evaluationTypeId}>
                                                    {obj.evaluationType}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </td>
                                <td className='text-center'>
                                    <input
                                        type="checkbox"
                                        defaultChecked={obj.flgSelective}
                                        onClick={(e) => handleCboxChange(obj.subjectId, 'flgSelective', e.target.checked)} />
                                </td>

                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
        <div className='col-sm-12' style={{ marginTop: 5 }}>
            <button
                type='button'
                className='btn btn-info pull-right'
                onClick={(e) => saveSybSubject(syllabusId, lstTmpSubject)}>
                Save
            </button>
        </div>
    </div>;
};
